"use client";

import React from "react";
import { Check, ShieldCheck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const advantages = ["Professional Drywall Installation & Repair", "Interior & Exterior Precision Painting", "Expert Project Management Solutions", "Complete Residential Demo & Hauling", "Quality Toilet & Vanity Installation"];
export default function TheGuardianDifference() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="148735" id="our-craftsmanship" className="bg-background py-24 md:py-32 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className={`transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="size-5 text-primary" />
              <span className="text-primary font-mono tracking-widest uppercase text-xs">
                01 / ABOUT
              </span>
            </div>
            
            <h2 className="text-foreground font-default font-bold text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight uppercase tracking-tighter">
              The Smith & B Standard
            </h2>
            
            <div className="space-y-6 text-foreground/80 font-sans text-lg leading-relaxed">
              <p>
                At SMITH & B GROUP LLC, we redefine residential restoration through technical precision and architectural excellence. Based in Florida, our team specializes in high-quality drywall installation and repair, ensuring your walls are perfectly primed for the finishing touch.
              </p>
              <p>
                From professional interior and exterior painting to residential demolition and hauling, our project management team ensures excellence. Call us at 954-681-5265 to begin your transformation with the quality you deserve.
              </p>
            </div>
          </div>

          {}
          <div ref={listRef} className={`bg-card p-8 md:p-10 rounded-sm border border-border shadow-sm transition-all duration-1000 delay-300 ease-out ${isListVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h3 className="text-foreground font-default font-bold text-xl mb-6 uppercase tracking-tight">Core Specialties</h3>
            <div className="flex flex-col">
              {advantages.map((advantage, i) => <div key={i} data-index={i} className="flex flex-col">
                  <div className="flex items-start gap-4 py-5 group">
                    <div className="bg-primary/10 p-2 rounded-sm shrink-0 transition-colors duration-300 group-hover:bg-primary/20">
                      <Check className="size-5 text-primary" strokeWidth={3} />
                    </div>
                    <span className="text-foreground font-medium text-lg pt-1 transition-colors duration-300 group-hover:text-primary">
                      {advantage}
                    </span>
                  </div>
                  {i < advantages.length - 1 && <Separator className="bg-border" />}
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}